import { combineReducers } from "redux"
import qualityReport from "./reports"

const qualityReportReducer = combineReducers({
  qualityReport,
})

export default qualityReportReducer
